export enum SessionStorageKeys {
  // Global
  Config                    = 'config',
  FeatureFlags              = 'featureFlags',
  Auth                      = 'auth',
  Collaborator              = 'collaborator',
  Locale                    = 'locale',
  ProjectSummary            = 'projectSummary',

  // Email templates
  InviteEmailTemplates      = 'inviteEmailTemplates',
  ApproverEmailTemplates    = 'approverEmailTemplates',
  RaterEmailTemplates       = 'raterApprovalEmailTemplates',
  EQScoresEmailTemplates    = 'eqScoresEmailTemplates',

  // Email tags
  CustomEmailTxt            = 'customEmailTxt',
  CustomEmailLogo           = 'customEmailLogo',
  CustomEmailParticipant    = 'customEmailParticipant',
  CustomEmailSurvey         = 'customEmailSurvey',
  CustomEmailDateDue        = 'customEmailDateDue',
  CustomEmailRatersApproved = 'customEmailRatersApproved',
  CustomEmailRatersDeclined = 'customEmailRatersDeclined',
  CustomEmailRatersAdded    = 'customEmailRatersAdded',

  // Specific to the share EQ scores email template
  EQScores                  = 'eqScores',
  EQScoresEmailTxt          = 'eqScoresEmailTxt',
  ProjectCSContact          = 'projectCSContact',
}
